document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const sections = gsap.utils.toArray('.shopify-section');

  sections.forEach((section) => {
    if (
      section.closest('header') ||
      section.closest('footer') ||
      section.classList.contains('shopify-section-header')
    ) return;

    gsap.from(section, {
      opacity: 0,
      y: 34,
      duration: 0.85,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 86%',
        once: true
      }
    });

    const children = section.querySelectorAll(
      'h1, h2, h3, .rich-text__text, .image-with-text__text, .button, .banner__buttons, .multicolumn-card, .card-wrapper, .product-card-wrapper'
    );

    if (children.length) {
      gsap.from(children, {
        opacity: 0,
        y: 22,
        duration: 0.65,
        ease: 'power3.out',
        stagger: 0.08,
        scrollTrigger: {
          trigger: section,
          start: 'top 82%',
          once: true
        }
      });
    }
  });

  const productPageItems = document.querySelectorAll(
    '.product__media-wrapper, .product__info-wrapper, .offer-box, .stahk-offer-panel, .stahk-trust-row, .product__accordion'
  );

  gsap.from(productPageItems, {
    opacity: 0,
    y: 26,
    duration: 0.75,
    ease: 'power3.out',
    stagger: 0.1,
    scrollTrigger: {
      trigger: '.product',
      start: 'top 78%',
      once: true
    }
  });
});